/**
 * Push notification message templates for Correly.
 * Used by the notification service (Phase 6 — Firebase).
 */

const supplementReminders = [
  (name, dosage) => `Hey! Time for your ${name} — ${dosage}. You've got this.`,
  (name, dosage) => `Friendly reminder: ${name} before bed tonight. Sweet dreams ahead.`,
  (name) => `Your afternoon supplements are ready when you are. Take them with lunch.`,
  () => `Time for your evening routine. Your body will thank you tomorrow.`,
  () => `Just a nudge — your morning supplements are waiting. Start the day strong.`,
];

const missedTaskMessages = [
  `No worries if you missed your morning dose — there's still time. Take it when you can.`,
  `Life gets busy. Whenever you're ready, your supplements are there for you.`,
];

const dailyLogReminders = [
  `How are you feeling today? Take a minute to log — your future self will appreciate it.`,
  `Quick check-in time. Your practitioner loves seeing how you're doing.`,
  `End your day with a moment of reflection. How did today go?`,
];

const practitionerMessageNotification = `Your practitioner sent you a message. Tap to read.`;

/**
 * Get a random supplement reminder message.
 */
export function getSupplementReminder(supplementName, dosage) {
  const template = supplementReminders[Math.floor(Math.random() * supplementReminders.length)];
  return template(supplementName, dosage);
}

/**
 * Get a random missed task message.
 */
export function getMissedTaskMessage() {
  return missedTaskMessages[Math.floor(Math.random() * missedTaskMessages.length)];
}

/**
 * Get a random daily log reminder.
 */
export function getDailyLogReminder() {
  return dailyLogReminders[Math.floor(Math.random() * dailyLogReminders.length)];
}

/**
 * Check if current time is in quiet hours (10pm–7am).
 */
export function isQuietHours() {
  const hour = new Date().getHours();
  return hour >= 22 || hour < 7;
}

export { practitionerMessageNotification };
